import { Config, ConfigMember } from "@/config";
import { ICommunityClaimPlaceSubmitData, ICommunityCreatePlaceSubmitData } from "@/interfaces/community/verify-place";
import axios from "axios";

interface ApiResponseCommunityClaimPlaceSubmit {
    success?: boolean;
    message?: string;
    [key: string]: any;
}

export const ApiCommunityClaimSelectedPlace = async (placeId: any) => {
    try {
        const dataBody = JSON.stringify({
            "placeId": placeId
        });

        const response = await axios({
            method: 'post',
            maxBodyLength: Infinity,
            url: ConfigMember.apiEndpoint + `v1/utility/claim-selected-place`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: "Basic " + Config.encoded,
            },
            data: dataBody,
        });

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Error response:', error.response);
                return error.response.data;
            }
            console.error('Error message:', error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        return { error: 'An error occurred while claiming the selected place.' };
    }
};

export const ApiCommunitySearchPark = async (
    type: number,
    searchName: string = "",
    provinceName: string = "",
    categorySlug: string = "",
    offset: number = 0,
    limit: number = 10,
    provideOption: boolean | string
) => {
    try {
        const dataBody = JSON.stringify({
            type,
            searchName,
            provinceName,
            categorySlug,
            offset,
            limit,
            provideOption
        });

        const response = await axios({
            method: 'post',
            maxBodyLength: Infinity,
            url: ConfigMember.apiEndpoint + `v1/search/`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: "Basic " + Config.encoded,
            },
            data: dataBody,
        });

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Error response:', error.response);
                return error.response.data;
            }
            console.error('Error message:', error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        return { error: 'An error occurred while searching for parks.' };
    }
};

export const ApiCommunityClaimPlaceSubmit = async (dataBody: ICommunityClaimPlaceSubmitData): Promise<ApiResponseCommunityClaimPlaceSubmit> => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: ConfigMember.apiEndpoint + `v1/utility/claim-submit`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: "Basic " + Config.encoded,
            },
            data: JSON.stringify(dataBody)
        };

        const response = await axios(config);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Error response:', error.response);
                return error.response.data;
            }
            console.error('Error message:', error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        return { error: 'An error occurred while submitting the claim.' };
    }
};

export const ApiCommunityCreatePlaceSubmit = async (dataBody: ICommunityCreatePlaceSubmitData): Promise<ApiResponseCommunityClaimPlaceSubmit> => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: ConfigMember.apiEndpoint + `v1/utility/claim-request-create-submit`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: "Basic " + Config.encoded,
            },
            data: JSON.stringify(dataBody)
        };

        const response = await axios(config);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Error response:', error.response);
                return error.response.data;
            }
            console.error('Error message:', error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        return { error: 'An error occurred while submitting the claim.' };
    }
};

export const ApiCommunityGetPlaceCategory = async (): Promise<ApiResponseCommunityClaimPlaceSubmit> => {
    try {
        const config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: ConfigMember.apiEndpoint + `v1/search/get-place-category`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: "Basic " + Config.encoded,
                // "x-access-token": token,
            },
        };
        const response = await axios(config);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Error response:', error.response);
                return error.response.data;
            }
            console.error('Error message:', error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        return { error: 'An error occurred while submitting the claim.' };
    }
};

export const GetPlacInfo = async (token: string, slug: string) => {
    try {
        const response = await axios({
            method: "get",
            maxBodyLength: Infinity,
            url: `${ConfigMember.apiEndpoint}v1/place/get-place-info/${slug}`,
            headers: {
                "accept-language": "th",
                "x-access-token": token,
                "Authorization": `Basic ${ConfigMember.encoded}`,
                "Content-Type": "application/json"
            },
        })
        return response?.data
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            error = error.response;
            return error;
        }
    }
}